import { useMemo, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import Base from './Base';
import { SessionProvider } from './context/SessionContext';
import { Theme, UserContext, UserData } from './context/UserContext';

// const QUERY_RETRY_COUNT = 3;

// function shouldRetry(failureCount: number, error): boolean {
//   return error?.response?.status !== 404 && failureCount < QUERY_RETRY_COUNT;
// }

const themeStorageKey = 'cs-genie-theme';
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

interface GenieProps {
  userData: UserData;
  standalone?: boolean;
  standaloneUrl?: string;
}

const Index = function Root({ userData, standalone, standaloneUrl }: GenieProps): React.ReactElement {
  // Temporary here, i expect we will receive current theme from outside
  const [theme, setTheme] = useState<Theme>(localStorage.getItem(themeStorageKey) === 'dark' ? 'dark' : 'light');
  const userValue = useMemo(
    () => ({
      theme,
      setTheme: (theme: Theme) => {
        setTheme(theme);
        localStorage.setItem(themeStorageKey, theme);
      },
      ...userData,
    }),
    [userData, standalone, standaloneUrl, theme, setTheme]
  );
  return (
    <QueryClientProvider client={queryClient}>
      <UserContext.Provider value={userValue}>
        <SessionProvider>
          <Base standalone={standalone} standaloneUrl={standaloneUrl} />
        </SessionProvider>
      </UserContext.Provider>
    </QueryClientProvider>
  );
};

export default Index;
